import template from './sales-details-report.html';
import controller from './sales-details-report.controller';
import './sales-details-report.scss';

let SalesDetailsReportComponent = {
  bindings: {},
  template,
  controller
};

export default SalesDetailsReportComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-details-report/sales-details-report.component.js